import { createSlice } from '@reduxjs/toolkit';

export const guestPlpBackUrl = createSlice({
  name: 'guestPlpBackUrl',
  initialState: {
    data: '',
  },

  reducers: {
    setGuestPlpBackUrl: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setGuestPlpBackUrl } = guestPlpBackUrl.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getGuestPlpBackUrl = (state) => {
  return state.guestPlpBackUrl.data;
};

export default guestPlpBackUrl.reducer;
